import { computed } from 'vue'

import type { BrandedKeywords } from '../models/definition.types'

import { useWorkspaceAttribute } from '@/features/workspace-settings'

const EMPTY_KEYWORDS: Required<BrandedKeywords> = {
  branded_company: [],
  branded_competitors: [],
  branded_slug: [],
}

export type KeywordAreaField = keyof BrandedKeywords

export function useKeywordArea(field: KeywordAreaField, max = 5) {
  const attribute = useWorkspaceAttribute('branded_keywords')
  const keywords = computed(() => attribute.value.value?.[field] ?? [])

  async function save(next: readonly string[]) {
    const normalized = next
      .map((value) => value.trim().toLowerCase())
      .filter(Boolean)
      .slice(0, max)
    const current = attribute.value.value ?? EMPTY_KEYWORDS
    return attribute.save({ ...EMPTY_KEYWORDS, ...current, [field]: normalized })
  }

  return { keywords, max, pending: attribute.pending, error: attribute.error, save }
}
